import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthenticatedRoute = ({ children }) => {
  const isAuthenticated = useSelector(state => !!state.auth.email); 

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default AuthenticatedRoute;
